(() => {
  if (window.naladirseBagConfirmationReady) return;
  window.naladirseBagConfirmationReady = true;
  let busy = false;
  let sourceButton;
  const panel = () => document.querySelector('[data-bag-confirmation]');
  const root = () => window.Shopify?.routes?.root || '/';
  const label = key => panel()?.dataset[key] || '';
  const cartPage = () => document.querySelector('[data-cart-page]');
  const sectionIds = () => ['cart-drawer', cartPage()?.dataset.sectionId].filter(Boolean);
  const dismiss = () => {
    const notice = panel();
    if (!notice) return;
    const restore = notice.contains(document.activeElement);
    notice.hidden = true;
    if (restore && sourceButton?.isConnected) sourceButton.focus({ preventScroll: true });
  };
  const message = (text, product = '', error = false) => {
    const notice = panel();
    if (notice) {
      notice.querySelector('[data-bag-message]').textContent = text;
      notice.querySelector('[data-bag-product]').textContent = product;
      notice.hidden = false;
    }
    document.querySelectorAll('[data-cart-status]').forEach(status => {
      status.textContent = text;
      if (error && (status.closest('dialog')?.open || !status.closest('dialog'))) status.focus({ preventScroll: true });
    });
  };
  const updateCount = count => {
    if (count == null) return;
    document.querySelectorAll('.bag').forEach(link => {
      const badge = link.querySelector('.badge');
      if (badge) badge.textContent = count;
      link.setAttribute('aria-label', (link.getAttribute('aria-label') || '').replace(/:\s*\d+$/, '') + ': ' + count);
    });
  };
  const renderSections = sections => {
    const parser = new DOMParser();
    let complete = true;
    for (const id of sectionIds()) {
      const html = sections?.[id];
      const selector = id === 'cart-drawer' ? '#cart' : '[data-cart-page]';
      const fresh = html && parser.parseFromString(html, 'text/html').querySelector(selector);
      const previous = document.querySelector(selector);
      if (!fresh || !previous) { complete = false; continue; }
      const active = previous.contains(document.activeElement) ? document.activeElement : null;
      const activeId = active?.id;
      const scroll = previous.querySelector('.drawer-items')?.scrollTop || 0;
      const formScroll = previous.querySelector('.drawer-form')?.scrollTop || 0;
      previous.innerHTML = fresh.innerHTML;
      previous.dataset.itemCount = fresh.dataset.itemCount;
      delete previous.dataset.stale;
      updateCount(fresh.dataset.itemCount);
      const items = previous.querySelector('.drawer-items');
      if (items) items.scrollTop = scroll;
      const drawerForm = previous.querySelector('.drawer-form');
      if (drawerForm) drawerForm.scrollTop = formScroll;
      if (active) {
        const next = (activeId && document.getElementById(activeId)) || previous.querySelector('[data-cart-status]');
        next?.focus({ preventScroll: true });
      }
    }
    return complete;
  };
  const fetchSections = async () => {
    const url = new URL(location.href);
    url.searchParams.set('sections', sectionIds().join(','));
    const response = await fetch(url, { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error('section');
    if (!renderSections(await response.json())) throw new Error('section');
  };
  const reconcile = async result => {
    updateCount(result.item_count);
    if (renderSections(result.sections)) return true;
    try { await fetchSections(); return true; } catch {
      try {
        const response = await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (response.ok) updateCount((await response.json()).item_count);
      } catch {}
      document.querySelectorAll('#cart,[data-cart-page]').forEach(container => { container.dataset.stale = 'true'; });
      return false;
    }
  };
  const refreshWarning = () => {
    message(label('refreshError'), '', true);
    document.querySelectorAll('[data-cart-status]').forEach(status => {
      const link = document.createElement('a');
      link.href = root() + 'cart';
      link.textContent = label('refreshLabel');
      status.append(link);
    });
  };
  const changeCart = async (form, source, action, payload) => {
    if (busy) return;
    busy = true;
    sourceButton = source;
    const controls = [...document.querySelectorAll('[data-cart-form] input,[data-cart-form] button')];
    const states = controls.map(control => control.disabled);
    controls.forEach(control => { control.disabled = true; });
    form?.setAttribute('aria-busy', 'true');
    const line = source?.closest('[data-cart-line]');
    line?.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(root() + 'cart/' + action + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...payload, sections: sectionIds(), sections_url: location.pathname })
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || label('cartError'));
      const rendered = await reconcile(result);
      if (rendered) {
        message(label(action === 'change' && payload.quantity === 0 ? 'removed' : 'updated'));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: result } }));
      } else refreshWarning();
    } catch (error) {
      message(error instanceof TypeError || error instanceof SyntaxError ? label('cartError') : error.message || label('cartError'), '', true);
    } finally {
      controls.forEach((control, i) => { if (control.isConnected) control.disabled = states[i]; });
      form?.removeAttribute('aria-busy');
      line?.removeAttribute('aria-busy');
      busy = false;
    }
  };
  document.addEventListener('click', event => {
    if (event.target.closest('[data-dismiss-confirmation]')) dismiss();
    if (event.target.closest('[data-open-bag]')) {
      dismiss();
      if (document.getElementById('cart')?.dataset.stale === 'true' && !busy) {
        busy = true;
        fetchSections().catch(refreshWarning).finally(() => { busy = false; });
      }
    }
    const remove = event.target.closest('[data-cart-remove]');
    if (!remove) return;
    event.preventDefault();
    if (remove.closest('[data-stale="true"]')) { refreshWarning(); return; }
    changeCart(remove.closest('form'), remove, 'change', { id: remove.dataset.cartRemove, quantity: 0 });
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') dismiss(); });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (form.matches('[data-cart-form]')) {
      if (busy) { event.preventDefault(); return; }
      if (form.closest('[data-stale="true"]')) { event.preventDefault(); refreshWarning(); return; }
      if (event.submitter?.name === 'checkout') return;
      event.preventDefault();
      if (!form.reportValidity()) return;
      const updates = Object.fromEntries([...form.querySelectorAll('[data-cart-quantity]')].map(input => [input.dataset.lineKey, Number(input.value)]));
      changeCart(form, event.submitter, 'update', { updates });
      return;
    }
    if (!form.matches('.buy-form') || !form.querySelector('[data-product-submit]') || !panel()) return;
    event.preventDefault();
    if (busy || !form.reportValidity()) return;
    busy = true;
    sourceButton = form.querySelector('[data-product-submit]');
    const button = sourceButton;
    const originalLabel = button.textContent;
    const controls = [...form.querySelectorAll('button,input,select')];
    const states = controls.map(control => control.disabled);
    const data = new FormData(form);
    data.set('sections', sectionIds().join(','));
    data.set('sections_url', location.pathname);
    controls.forEach(control => { control.disabled = true; });
    form.setAttribute('aria-busy', 'true');
    button.textContent = label('adding');
    dismiss();
    let added = false;
    let errorMessage = label('error');
    try {
      const response = await fetch(root() + 'cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok || result.status) {
        errorMessage = result.description || result.message || errorMessage;
        throw new Error(errorMessage);
      }
      added = true;
      if (await reconcile(result)) {
        message(panel().getAttribute('aria-label'), form.closest('[data-native-product]')?.querySelector('h1')?.textContent || result.product_title || result.title || '');
        document.dispatchEvent(new CustomEvent('cart:updated'));
      } else refreshWarning();
    } catch {
      message(added ? label('refreshError') : errorMessage, '', true);
    } finally {
      controls.forEach((control, i) => { control.disabled = states[i]; });
      button.textContent = originalLabel;
      form.removeAttribute('aria-busy');
      busy = false;
    }
  });
})();
